module.exports = __webpack_public_path__ + "img/slika8_2022.873ac56a.png";